import { FC } from 'react';
import { Anchor, Image, Text, UnstyledButton } from '@mantine/core';
import { useDispatch } from 'react-redux';
import { creatorActions } from '@/store/slices/creatorSlice';
import classNames from 'classnames';
import HelpIcon from '@/assets/icons/help.svg?react';

interface Props {
	isSelected: boolean;
	name: string;
	description?: string;
	onSelect: () => void;
	imagePath?: string;
	onMouseOver?: () => void;
}

export const AccordionOptionCard: FC<Props> = ({
	isSelected,
	name,
	description,
	onSelect,
	imagePath,
	onMouseOver,
}) => {
	const dispatch = useDispatch();

	const handleOpenHelpDrawer = () => {
		dispatch(
			creatorActions.toogleHelpDrawer({
				helpDrawerOpened: true,
				helpDrawerData: {
					title: name,
					description,
					image: imagePath,
				},
			})
		);
	};

	return (
		<UnstyledButton
			className={classNames('option-card', {
				'option-card-selected': isSelected,
			})}
			onClick={onSelect}
			onMouseOver={onMouseOver}
		>
			<Anchor
				className="help-trigger"
				onClick={(e) => {
					e.stopPropagation();
					handleOpenHelpDrawer();
				}}
			>
				<HelpIcon />
			</Anchor>
			<Image src={imagePath} w="100%" h={60} loading="lazy" fit="cover" />
			<Text size="xs" fw="bold" tt="uppercase" py={8} px="sm">
				{name}
			</Text>
		</UnstyledButton>
	);
};
